<template>
    <div class="categories-filters">
        <v-card class="my-4 border-transparent" outlined v-if="layoutRegion">
            <div class="px-2">
                <base-search
                    :key="layoutRegion.systemName"
                    :label="layoutRegion.label"
                    :category-id="id"
                    :chips="true"
                    @value-change="updateList"
                    :multiple="true"
                    :reset-filter="systemName"
                    :reset-force="resetForce"
                    :filter-key="filterKey"
                    :search-name="layoutRegion.systemName"
                    :external-items="layoutRegion.valuesData"
                    :has-external="true"
                ></base-search>
            </div>
        </v-card>
        <v-card class="my-4 border-transparent" outlined v-if="generalSwitches.length">
            <v-list class="my-n4" dense flat>
                <v-list-item
                    class="px-4"
                    v-for="switcher in generalSwitches"
                    :key="switcher.systemName"
                >
                    <div class="d-flex justify-space-between align-baseline" style="width: 100%">
                        <v-list-item-title>{{switcher.label}}</v-list-item-title>
                        <filter-switch
                            :filter-key="filterKey"
                            :filter-name="switcher.systemName"
                            :reset-filter="systemName"
                            @value-change="updateList"
                        ></filter-switch>
                    </div>
                </v-list-item>
            </v-list>
        </v-card>
        <v-card class="border-transparent" outlined v-if="layoutExistence">
            <v-card-text>
                <base-search-single
                    :key="layoutExistence.systemName"
                    :label="layoutExistence.label"
                    :search-name="layoutExistence.systemName"
                    :external-items="layoutExistence.valuesData"
                    :has-external="true"
                    :reset-filter="systemName"
                    :reset-force="resetForce"
                    :filter-key="filterKey"
                    @value-change="updateList"
                ></base-search-single>
            </v-card-text>
        </v-card>
        <v-card class="border-transparent" outlined v-if="layoutManufacturer">
            <v-card-text>
                <base-search
                    :key="layoutManufacturer.systemName"
                    :attribute-name="layoutManufacturer.attributeSystemName"
                    :label="layoutManufacturer.label"
                    :category-id="id"
                    :chips="true"
                    @value-change="updateList"
                    :multiple="true"
                    :reset-filter="systemName"
                    :reset-force="resetForce"
                    :filter-key="filterKey"
                    :search-name="layoutManufacturer.systemName"
                    :external-items="layoutManufacturer.valuesData"
                    :has-external="true"
                ></base-search>
            </v-card-text>
        </v-card>
        <v-card class="border-transparent" outlined>
            <v-card-text>
                <filter-price
                    :filter-key="filterKey"
                    @value-change="updateList"
                    :reset-filter="systemName"
                ></filter-price>
            </v-card-text>
        </v-card>
        <v-card class="my-2 border-transparent" outlined v-if="layoutCategoryFilters.length">
            <v-card-text>
                <base-search
                    v-for="filter in layoutCategoryFilters"
                    v-if="isAutocompleteMultiple(filter.type)"
                    :attribute-name="filter.attributeSystemName"
                    :key="filter.systemName"
                    :label="filter.label"
                    :category-id="id"
                    :chips="true"
                    @value-change="updateList"
                    :multiple="true"
                    :reset-filter="systemName"
                    :reset-force="resetForce"
                    :filter-key="filterKey"
                    :search-name="filter.systemName"
                    :external-items="updateValuesData(filter.valuesData)"
                    :has-external="true"
                    item-text="name_with_count"
                ></base-search>
                <base-search-single
                    v-for="filter in layoutCategoryFilters"
                    v-if="isAutocomplete(filter.type)"
                    :key="filter.systemName"
                    :attribute-name="filter.attributeSystemName"
                    :label="filter.label"
                    :category-id="id"
                    @value-change="updateList"
                    :reset-filter="systemName"
                    :reset-force="resetForce"
                    :filter-key="filterKey"
                    :search-name="filter.systemName"
                    :external-items="updateValuesData(filter.valuesData)"
                    :has-external="true"
                    item-text="name_with_count"
                ></base-search-single>
            </v-card-text>
        </v-card>
        <div class="d-flex justify-center">
            <v-btn
                class="my-4 main--yellow hidden-md-and-up text-uppercase"
                depressed
                dark
                @click="$emit('apply')"
            >
                {{ $t('show') + ' ' + total + ' ' + $t('products')}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import BaseSearch from "../../../general/filters/base-search"
    import BaseSearchSingle from "../../../general/filters/base-search-single"
    import FiltersGeneral from "../../../app-front/mixins/FiltersGeneral"
    import FilterPrice from "../../../app-front/components/filters/FilterPrice"
    import FilterRegions from "../../../general/geo/regions"
    import FilterService from '../../../app-front/services/api/FilterService';
    import FilterSwitch from "../../../app-front/components/filters/FilterSwitch"
    import ManufacturerFilter from "../../../general/manufacturer/simple"


    export default {
        name: "GeneralFilters",
        props: ['id', 'systemName', 'total', 'filterKey'],
        mixins: [FiltersGeneral],
        components: {BaseSearch, BaseSearchSingle, FilterPrice, FilterSwitch, ManufacturerFilter, FilterRegions},
        data() {
            return {
                storeFilterKey: 'category',
                defaultLayout: null,
                resetForce: false
            }
        },
        computed: {
            currentId() {
                return this.id;
            },
            generalSwitches() {
                const switches = [];

                /*if (this.layoutDelivery) {
                    switches.push(this.layoutDelivery);
                }*/

                /*if (this.layoutExistence) {
                    switches.push(this.layoutExistence);
                }*/

                if (this.layoutDiscount) {
                    switches.push(this.layoutDiscount);
                }

                return switches;
            },
        },
        methods: {
            filterSelector(filterKey) {
                switch (filterKey) {
                    case "category":
                        return this.filtersGeneral.category.systemName;
                    case "attribute":
                        return this.filtersGeneral.awesomeEnum.systemName;
                    case "region":
                        return this.filtersGeneral.region.systemName;
                    default:
                        break;
                }
            },
            getFiltersLayout() {
                FilterService.setLocale(this.$store.state.language.appLanguage);
                FilterService.getGeneralLayout(this.id, this.filterKey)
                    .then(res => {
                        this.layoutData = res.data;
                        this.defaultLayout = res.data;
                        const filters = this.createFiltersFromApi(res.data);
                        filters[this.filterSelector(this.filterKey)] = [this.id];

                        const data = {
                            key: this.filterKey,
                            value: filters
                        };

                        this.$store.commit('setFilters', data);
                        this.mergeUrlFilters();
                        this.updateList();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            resetLayout() {
                this.layoutData = this.defaultLayout;
                this.activeFilters = {};
                this.resetForce = true;

                setTimeout(() => {
                    this.resetForce = false;
                }, 100);
            },
            updateValuesData(valuesData) {
                return valuesData
                    .map(item => ({
                        ...item,
                        name_with_count: `${item.name} (${item.product_count})`
                    }))
            },
        },
        created() {
            if (this.currentId) {
                this.getFiltersLayout()
            }
        },
        watch: {
            currentId() {
                this.getFiltersLayout();
                this.resetFilters = true;
            }
        },
    }
</script>
